export default function HeroSection() {
  const scrollToCadastro = () => {
    const el = document.getElementById("cadastro");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[760px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/img/readdy/56ca323d1966.jpg"
          alt="Mulheres brasileiras unidas em acolhimento"
          className="w-full h-full object-cover object-top"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 text-center pt-20">
        <p className="font-body text-xs md:text-sm tracking-[0.25em] uppercase text-white/80 mb-6">
          Comunidade Feminina
        </p>
        <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight max-w-4xl mx-auto mb-6">
          Um espaço de conexão, fé e crescimento entre mulheres
        </h1>
        <p className="font-body text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
          Entre Elas é mais do que um encontro. É uma rede de apoio onde mulheres
          se conectam, crescem juntas e constroem propósito.
        </p>
        <button
          onClick={scrollToCadastro}
          className="font-body text-sm md:text-base px-8 py-4 rounded-full bg-primary text-white tracking-wide uppercase transition-all duration-300 hover:bg-primary-dark hover:scale-[1.02] whitespace-nowrap"
        >
          Quero fazer parte
        </button>
      </div>
    </section>
  );
}